import React from "react";
import "../../styles/HomeAbout.css";

const HomeAbout = () => {
  return (
    <div className="home-about">
      <div>
        <h1>WELCOME TO GREENWORKS CONSULTING</h1>
        
        <p style={{textAlign: "justify",}}>
          At GreenWorks Consulting, we specialize in providing comprehensive advisory  services, from origination to action and results to impacts. 
          We provide end-to-end project development and management support: from developing winning concept note-to-proposals to securing funding for managing full-scale 
          implementation and ensuring successful project completion.
        </p>
      </div>
    </div>
  );
};

export default HomeAbout;
